import { useState, useRef, useEffect } from 'react';
import { Checkbox } from '@appkit4/react-components';
import './DocumentTypeFilter.scss';

interface DocumentTypeFilterProps {
    onSelect: (selectedTypes: string[]) => void;
    options: { value: string; desc: string }[];
    selectedDocTypes: string[];
}

const DocumentTypeFilter = ({
    onSelect,
    options,
    selectedDocTypes,
}: DocumentTypeFilterProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedTypes, setSelectedTypes] =
        useState<string[]>(selectedDocTypes);
    const dropdownRef = useRef(null);

    useEffect(() => {
        setSelectedTypes(selectedDocTypes);
    }, [selectedDocTypes]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !(dropdownRef.current as HTMLDivElement).contains(
                    event.target as Node
                )
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (type: string) => {
        const newSelectedTypes = selectedTypes.includes(type)
            ? selectedTypes.filter((t) => t !== type)
            : [...selectedTypes, type];
        setSelectedTypes(newSelectedTypes);
        onSelect(newSelectedTypes);
    };

    return (
        <div ref={dropdownRef} style={{ position: 'relative' }}>
            <span
                className="Appkit4-icon icon-filter-outline"
                onClick={() => setIsOpen(!isOpen)}
                style={{ cursor: 'pointer' }}
            />
            {isOpen && (
                <div className="dropdown-filter">
                    {options.map((option) => (
                        <div key={option.value} style={{ padding: '10px 8px' }}>
                            <Checkbox
                                checked={selectedTypes.includes(option.value)}
                                onChange={() => handleSelect(option.value)}
                                style={{ fontWeight: 'normal' }}
                            >
                                {option.desc}
                            </Checkbox>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DocumentTypeFilter;
